import * as types from "../../actions/types/index";
import {setInitialState} from "../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
    private_broadcast_payload:null
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.CREATE_BROADCAST_REQUEST:
        case types.CREATE_TEST_BROADCAST_REQUEST:
        case types.UPDATE_BROADCAST_REQUEST:
        case types.UPDATE_BROADCASTER_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.CREATE_BROADCAST_RECEIVE:
        case types.CREATE_TEST_BROADCAST_RECEIVE:
        case types.UPDATE_BROADCAST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload.success
            };
        case types.UPDATE_BROADCASTER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true
            };
        case types.CREATE_BROADCAST_FAILURE:
        case types.CREATE_TEST_BROADCAST_FAILURE:
        case types.UPDATE_BROADCAST_FAILURE:
        case types.UPDATE_BROADCASTER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.RESET_CREATE_BROADCAST:
        case types.RESET_CREATE_TEST_BROADCAST:
        case types.RESET_UPDATE_BROADCAST:
            return {
                ...state,
                payload: action.payload,
            };
        case types.CREATE_PRIVATE_BROADCAST_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.CREATE_PRIVATE_BROADCAST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                private_broadcast_payload: action.payload.success
            };
        case types.CREATE_PRIVATE_BROADCAST_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                private_broadcast_payload: action.payload.response.error,
            };
        case types.RESET_CREATE_PRIVATE_BROADCAST:
            return {
                ...state,
                private_broadcast_payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}